/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorIconPrimary = "#EF7A7E";
export const ColorBackgroundPrimary = "#F0E8DA";
export const ColorBackgroundSecondary = "#B38B44";
export const ComponentsCtaPrimaryTextDefault = "#1A1A1A";
export const ComponentsCtaPrimaryIconDefault = "#1A1A1A";
export const ComponentsCtaPrimaryBgDefault = "#B38B44";
export const ComponentsCtaPrimaryBgHover = "#C2A269";
export const ComponentsCtaPrimaryBgPressed = "#C2A269";
export const ComponentsCtaPrimaryBgFocused = "#D1B98F";
export const ComponentsCtaPrimaryBorderDefault = "transparent";
export const ComponentsCtaPrimaryBorderHover = "transparent";
export const ComponentsCtaPrimaryBorderPressed = "transparent";
export const ComponentsCtaPrimaryBorderFocus = "transparent";
